import React from 'react'
import classNames from 'classnames'
import styles from './style.module.scss'

class FileTypeIcon extends React.Component {
  state = {
    imgSrc: '',
    text: null,
    size: null,
    alt: '',
  }

  componentDidMount() {
    this.applyProps()
  }

  componentDidUpdate(prevProps) {
    const { fileName, fileType, size } = this.props

    if (
      fileName !== prevProps.fileName ||
      fileType !== prevProps.fileType ||
      size !== prevProps.size
    ) {
      this.applyProps()
    }
  }

  componentWillUnmount() {}

  applyProps = () => {
    const { fileName, fileType, size } = this.props

    // console.log(fileName, fileType, size)

    let info = null
    let text = null
    let alt = 'file'
    if (fileName != null) {
      const pos = fileName.lastIndexOf('.')
      const ext = fileName.substring(pos + 1)
      info = this.getImageInfo(ext)
      alt = ext
      text = info.type === 'general' ? ext : null
    } else if (fileType != null) {
      info = this.getImageInfo(fileType)
      text = info.type === 'general' ? fileType : null
      alt = fileType
    } else {
      info = this.getImageInfo('')
    }

    this.setState({
      imgSrc: info.path,
      text,
      size,
      alt,
    })
  }

  getImageInfo = (fileType) => {
    let imgFileName = ''
    const type = fileType.toLowerCase()
    switch (type) {
      case 'xd':
        imgFileName = 'file-xd.svg'
        break

      case 'ae':
        imgFileName = 'file-after-effects.svg'
        break

      case 'key':
      case 'pages':
      case 'numbers':
        imgFileName = 'file-apple.svg'
        break

      case 'apk':
      case '7z':
      case 'arj':
      case 'deb':
      case 'pkg':
      case 'rar':
      case 'rpm':
      case 'z':
      case 'zip':
      case 'tar':
      case 'alzip':
      case 'bzip':
      case 'gz':
      case 'egg':
      case 'tbz':
      case 'tgz':
      case 'zipx':
      case 'iso':
      case 'ais':
      case 'cab':
      case 'hgz':
      case 'gas':
      case 'pak':
      case 'psz':
      case 'sea':
      case 'zool':
      case 'alz':
      case 'ace':
      case 'arc':
      case 'b64':
      case 'bh':
      case 'bin':
      case 'bz2':
      case 'ear':
      case 'enc':
      case 'ha':
      case 'hqx':
      case 'ice':
      case 'lcd':
      case 'lha':
      case 'mim':
      case 'uue':
      case 'war':
      case 'xxe':
      case 'x':
      case 'zoo':
      case 'lzh':
      case 'jar':
        imgFileName = 'file-archive.svg'
        break

      case 'mp3':
      case 'music':
      case 'wav':
      case 'ogg':
      case 'mpa':
      case 'wma':
      case 'aif':
      case 'cda':
      case 'mid':
      case 'midi':
      case 'wpl':
        imgFileName = 'file-audio.svg'
        break

      case 'cell':
      case 'nxl':
        imgFileName = 'file-cell.svg'
        break

      case 'c':
      case 'cpp':
      case 'cs':
      case 'java':
      case 'js':
      case 'json':
      case 'php':
      case 'py':
        imgFileName = 'file-code.svg'
        break

      case 'css':
        imgFileName = 'file-css.svg'
        break

      case 'eml':
      case 'email':
      case 'emlx':
      case 'msg':
        imgFileName = 'file-eml.svg'
        break

      case 'xls':
      case 'xlsx':
      case 'xlsm':
      case 'odx':
        imgFileName = 'file-excel.svg'
        break

      case 'html':
      case 'htm':
        imgFileName = 'file-html.svg'
        break

      case 'hwp':
      case 'hwx':
      case 'hwpx':
        imgFileName = 'file-hwp.svg'
        break

      case 'ical':
      case 'ics':
      case 'ifb':
        imgFileName = 'file-ical.svg'
        break

      case 'ai':
        imgFileName = 'file-illustrator.svg'
        break

      case 'jpeg':
      case 'jpg':
      case 'png':
      case 'git':
      case 'bmp':
      case 'icon':
      case 'tif':
      case 'tiff':
      case 'heic':
      case 'webp':
      case 'exif':
      case 'svg':
        imgFileName = 'file-image.svg'
        break

      case 'pdf':
        imgFileName = 'file-pdf.svg'
        break

      case 'psd':
        imgFileName = 'file-photoshop.svg'
        break

      case 'ppt':
      case 'pptx':
      case 'odp':
      case 'pps':
        imgFileName = 'file-powerpoint.svg'
        break

      case 'hwd':
      case 'hwn':
      case 'show':
        imgFileName = 'file-show.svg'
        break

      case 'swf':
        imgFileName = 'file-swf.svg'
        break

      case 'txt':
      case 'md':
        imgFileName = 'file-text.svg'
        break

      case 'vcard':
      case 'vcf':
        imgFileName = 'file-vcard.svg'
        break

      case 'mp4':
      case 'avi':
      case 'mpg':
      case 'wmv':
      case 'mpeg':
      case 'mov':
      case 'asf':
      case 'video':
      case 'mkv':
      case 'flv':
      case 'h264':
      case '3gp':
      case '3g2':
      case 'rm':
      case 'm4v':
      case 'vob':
        imgFileName = 'file-video.svg'
        break

      case 'doc':
      case 'docx':
      case 'odt':
      case 'rtf':
      case 'wpd':
      case 'tex':
        imgFileName = 'file-word.svg'
        break

      default:
        imgFileName = 'file-unknown.svg'
    }

    return {
      path: `/resources/images/exts/${imgFileName}`,
      type,
    }
  }

  render() {
    const { imgSrc, text, size, alt } = this.state
    const { className } = this.props

    const styleProps = {}
    if (size != null) {
      styleProps.width = size
    }

    const textElem = text != null ? <div className={classNames('type')}>{text}</div> : ''

    return (
      <div className={classNames(styles.ftIcon, 'ftIcon', className)}>
        <img src={imgSrc} style={styleProps} alt={alt} />
        {textElem}
      </div>
    )
  }
}

export default FileTypeIcon
